export const colors = {
  primary1: '#26C6DA',
  primary2: '#2C5252',
  primary3: '#419470',
  primary4: '#1596A6',
  neutral1: '#191617',
  neutral2: '#768692',
  neutral3: '#BCC6CC',
  secondary1: '#233D4D',
  secondary2: '#FFB100',
  secondary3: '#F95738',
  white: '#ffffff',
  backgroundColor1: '#ffffff',
  primary: {
    black: '#000000',
    white: '#FFFFFF',
    warmWhite: '#f5f0e6',
  },
  secondary: {
    humanTeal: '#26a9ab',
    vibrantIndigo: '#b0c2ff',
    earth: '#b8a58b',
    spark: '#d8fd8a',
  },
  tertiary: {
    humanRed: '#ff7163',
    industrialGreen: '#84e2ae',
    urbanPurple: '#9562f4',
  },
};

export const borderRadius = {
  small: '4px',
  medium: '10px',
};
